import { useQuery } from "@tanstack/react-query";
import { getGithubRepositoryStats } from "./api";

const githubRepositoryStatsStaleTimeMs = 5 * 60 * 1000;

export const githubKeys = {
  all: ["github"] as const,
  repositories: () => [...githubKeys.all, "repositories"] as const,
  repositoryStats: (repoUrl: string) =>
    [...githubKeys.repositories(), repoUrl, "stats"] as const,
};

export function githubRepositoryStatsQueryOptions(repoUrl: string) {
  return {
    queryKey: githubKeys.repositoryStats(repoUrl),
    queryFn: () => getGithubRepositoryStats(repoUrl),
    staleTime: githubRepositoryStatsStaleTimeMs,
  };
}

export function useGithubRepositoryStatsQuery(
  repoUrl: string,
  enabled: boolean = true,
) {
  return useQuery({
    ...githubRepositoryStatsQueryOptions(repoUrl),
    enabled: enabled && Boolean(repoUrl),
  });
}
